// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import { Tag } from "antd";
import { NEWS_THEME_STATUS } from "../../../../utils/Constant";
import { NewsThemeStatusTagProps } from "../../../types/NewsThemeTypes";

const NewsThemeStatusTag: React.FunctionComponent<NewsThemeStatusTagProps> = (
  props: NewsThemeStatusTagProps
) => {
  const { publicationDate } = props;

  const newsThemeStatus = publicationDate
    ? NEWS_THEME_STATUS.PUBLISHED
    : NEWS_THEME_STATUS.UNPUBLISHED;

  return <Tag color={newsThemeStatus.color}>{newsThemeStatus.label}</Tag>;
};

export default NewsThemeStatusTag;
